import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import { json } from '../libs/utils/Const';
import moment from 'moment';
import Select from 'react-select';
import { ApiClient } from '../libs/apiClient';
const apiClient = ApiClient.getInstance();

class UserFieldsModal extends Component {

    closeUserFields = async () => {
        $('#userFieldsModal').modal('hide');
    };

    closeAction = () => {
        $('#userFieldsModal').on('hiden.bs.modal', function () {

        });
    };

    changeUserFieldsDocument = async (event, index) => {
        const { refreshModel, view, hanldeUserFields, setWhsByRouteDocs, getDimension1ByUserField, checkWithHolding, checkItemPrices } = this.props;
        let { newOrderModel } = this.props;
        switch (index) {
            case 0:
                newOrderModel.userFields.userFields1 = event.nativeEvent.target.value;
                if (newOrderModel.isPurchaseDocument && (newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder')) {
                    newOrderModel = await checkWithHolding(newOrderModel);
                }
                break;
            case 1:
                newOrderModel.userFields.userFields2 = event.nativeEvent.target.value;
                await hanldeUserFields(index, event);
                break;
            case 2:
                newOrderModel.userFields.userFields3 = event.nativeEvent.target.value;
                break;
            case 3:
                newOrderModel.userFields.userFields4 = event.nativeEvent.target.value;
                break;
            case 4:
                newOrderModel.userFields.userFields5 = event.nativeEvent.target.value;
                break;
            case 5:
                newOrderModel.userFields.userFields6 = event.nativeEvent.target.value;
                break;
            case 6:
                newOrderModel.userFields.userFields7 = event.nativeEvent.target.value;
                break;
            case 7:
                newOrderModel.userFields.userFields8 = event.nativeEvent.target.value;
                break;
            case 8:
                newOrderModel.userFields.userFields9 = event.nativeEvent.target.value;
                break;
            case 9:
                newOrderModel.userFields.userFields10 = event.nativeEvent.target.value;
                break;
            case 10:
                newOrderModel.userFields.userFields11 = event.nativeEvent.target.value;
                break;
            case 11:
                newOrderModel.userFields.userFields12 = event.nativeEvent.target.value;
                break;
            case 12:
                newOrderModel.userFields.userFields13 = event.nativeEvent.target.value;
                break;
            case 13:
                newOrderModel.userFields.userFields14 = event.nativeEvent.target.value;
                break;
            case 14:
                newOrderModel.userFields.userFields15 = event.nativeEvent.target.value;
                break;
            case 15:
                newOrderModel.userFields.userFields16 = event.nativeEvent.target.value;
                break;
            case 16:
                newOrderModel.userFields.userFields17 = event.nativeEvent.target.value;
                break;
            case 17:
                newOrderModel.userFields.userFields18 = event.nativeEvent.target.value;
                break;
            case 18:
                newOrderModel.userFields.userFields19 = event.nativeEvent.target.value;
                break;
            case 19:
                newOrderModel.userFields.userFields20 = event.nativeEvent.target.value;
                break;
            case 20:
                newOrderModel.userFields.userFields21 = event.nativeEvent.target.value;
                break;
            case 21:
                newOrderModel.userFields.userFields22 = event.nativeEvent.target.value;
                break;
            case 22:
                newOrderModel.userFields.userFields23 = event.nativeEvent.target.value;
                break;
            case 23:
                newOrderModel.userFields.userFields24 = event.nativeEvent.target.value;
                break;
            case 24:
                newOrderModel.userFields.userFields25 = event.nativeEvent.target.value;
                break;
            case 25:
                newOrderModel.userFields.userFields26 = event.nativeEvent.target.value;
                break;
            case 26:
                newOrderModel.userFields.userFields27 = event.nativeEvent.target.value;
                break;
            case 27:
                newOrderModel.userFields.userFields28 = event.nativeEvent.target.value;
                if (newOrderModel?.isSalesDocument && newOrderModel?.DocType === 'I') {
                    await setWhsByRouteDocs(newOrderModel.userFields.userFields28);
                }
                // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && newOrderModel?.DocType === 'I') {
                if ((newOrderModel?.isSalesDocument) && newOrderModel?.DocType === 'I') {
                    await getDimension1ByUserField(newOrderModel.userFields.userFields28); // Se manda el tipo de atención
                    checkItemPrices(false, false, false, true, newOrderModel.userFields.userFields28);
                }
                break;
            case 28:
                newOrderModel.userFields.userFields29 = event.nativeEvent.target.value;
                if (newOrderModel?.isSalesDocument && newOrderModel?.DocType === 'I') {
                    await getDimension1ByUserField(null, newOrderModel.userFields.userFields29); // Se manda el canal de atención
                }
                break;
            case 29:
                newOrderModel.userFields.userFields30 = event.nativeEvent.target.value;
                // if ((newOrderModel?.isSalesDocument || newOrderModel?.isTransferDocument) && newOrderModel?.DocType === 'I') { // Se manda el tipo de venta
                if ((newOrderModel?.isSalesDocument) && newOrderModel?.DocType === 'I') { // Se manda el tipo de venta
                    checkItemPrices(false, false, true, false, '', true, newOrderModel.userFields.userFields30);
                }
                break;
            case 30:
                newOrderModel.userFields.userFields31 = event.nativeEvent.target.value;
                break;
            case 31:
                newOrderModel.userFields.userFields32 = event.nativeEvent.target.value;
                break;
            case 32:
                newOrderModel.userFields.userFields33 = event.nativeEvent.target.value;
                break;
            case 33:
                newOrderModel.userFields.userFields34 = event.nativeEvent.target.value;
                break;
            case 34:
                newOrderModel.userFields.userFields35 = event.nativeEvent.target.value;
                break;
            case 35:
                newOrderModel.userFields.userFields36 = event.nativeEvent.target.value;
                break;
            case 36:
                newOrderModel.userFields.userFields37 = event.nativeEvent.target.value;
                break;
            case 37:
                newOrderModel.userFields.userFields38 = event.nativeEvent.target.value;
                break;
            case 38:
                newOrderModel.userFields.userFields39 = event.nativeEvent.target.value;
                break;
            case 39:
                newOrderModel.userFields.userFields40 = event.nativeEvent.target.value;
                break;
            case 40:
                newOrderModel.userFields.userFields41 = event.nativeEvent.target.value;
                break;
            case 41:
                newOrderModel.userFields.userFields42 = event.nativeEvent.target.value;
                break;
            case 42:
                newOrderModel.userFields.userFields43 = event.nativeEvent.target.value;
                // if (view === 'orderSales') {
                //     await setWhsByRouteDocs();
                // }
                break;
            case 43:
                newOrderModel.userFields.userFields44 = event.nativeEvent.target.value;
                if (view === 'transfersEntry') {
                    await hanldeUserFields(index, event);
                }
                break;
            case 44:
                newOrderModel.userFields.userFields45 = event.nativeEvent.target.value;
                break;
            case 45:
                newOrderModel.userFields.userFields46 = event.nativeEvent.target.value;
                break;
            case 46:
                newOrderModel.userFields.userFields47 = event.nativeEvent.target.value;
                break;
            case 47:
                newOrderModel.userFields.userFields48 = event.nativeEvent.target.value;
                break;
            case 48:
                newOrderModel.userFields.userFields49 = event.nativeEvent.target.value;
                break;
            case 49:
                newOrderModel.userFields.userFields50 = event.nativeEvent.target.value;
                break;
            case 50:
                newOrderModel.userFields.userFields51 = event.nativeEvent.target.value;
                break;
            case 51:
                newOrderModel.userFields.userFields52 = event.nativeEvent.target.value;
                break;
            case 52:
                newOrderModel.userFields.userFields53 = event.nativeEvent.target.value;
                if (view === 'deliveries' || view === 'PurchaseOrder' || view === 'PurchaseQuotation') {
                    await hanldeUserFields(index, event);
                }
                break;
            case 53:
                newOrderModel.userFields.userFields54 = event.nativeEvent.target.value;
                break;
            case 54:
                newOrderModel.userFields.userFields55 = event.nativeEvent.target.value;

                break;
            case 55:
                newOrderModel.userFields.userFields56 = event.nativeEvent.target.value;
                break;
            case 56:
                newOrderModel.userFields.userFields57 = event.nativeEvent.target.value;
                break;
            case 57:
                newOrderModel.userFields.userFields58 = event.nativeEvent.target.value;
                break;
            case 58:
                newOrderModel.userFields.userFields59 = event.nativeEvent.target.value;
                break;
            case 59:
                newOrderModel.userFields.userFields60 = event.nativeEvent.target.value;
                break;
            case 60:
                newOrderModel.userFields.userFields61 = event.nativeEvent.target.value;
                break;
            case 61:
                newOrderModel.userFields.userFields62 = event.nativeEvent.target.value;
                break;
            case 62:
                newOrderModel.userFields.userFields63 = event.nativeEvent.target.value;
                break;
            case 63:
                newOrderModel.userFields.userFields64 = event.nativeEvent.target.value;
                break;
            case 64:
                newOrderModel.userFields.userFields65 = event.nativeEvent.target.value;
                break;
            case 65:
                newOrderModel.userFields.userFields66 = event.nativeEvent.target.value;
                break;
            case 66:
                newOrderModel.userFields.userFields67 = event.nativeEvent.target.value;
                break;
            case 67:
                newOrderModel.userFields.userFields68 = event.nativeEvent.target.value;
                break;
            case 68:
                newOrderModel.userFields.userFields69 = event.nativeEvent.target.value;
                break;
            case 69:
                newOrderModel.userFields.userFields70 = event.nativeEvent.target.value;
                break;
            case 70:
                newOrderModel.userFields.userFields71 = event.nativeEvent.target.value;
                break;
            case 71:
                newOrderModel.userFields.userFields72 = event.nativeEvent.target.value;
                break;
            case 72:
                newOrderModel.userFields.userFields73 = event.nativeEvent.target.value;
                break;
            case 73:
                newOrderModel.userFields.userFields74 = event.nativeEvent.target.value;
                break;
            case 74:
                newOrderModel.userFields.userFields75 = event.nativeEvent.target.value;
                break;
            case 75:
                newOrderModel.userFields.userFields76 = event.nativeEvent.target.value;
                break;
            case 76:
                newOrderModel.userFields.userFields77 = event.nativeEvent.target.value;
                break;
            case 77:
                newOrderModel.userFields.userFields78 = event.nativeEvent.target.value;
                break;
            case 78:
                newOrderModel.userFields.userFields79 = event.nativeEvent.target.value;
                break;
            case 79:
                newOrderModel.userFields.userFields80 = event.nativeEvent.target.value;
                break;
            case 80:
                newOrderModel.userFields.userFields81 = event.nativeEvent.target.value;
                break;
            case 81:
                newOrderModel.userFields.userFields82 = event.nativeEvent.target.value;
                break;
            case 82:
                newOrderModel.userFields.userFields83 = event.nativeEvent.target.value;
                break;
            case 83:
                newOrderModel.userFields.userFields84 = event.nativeEvent.target.value;
                break;
            case 84:
                newOrderModel.userFields.userFields85 = event.nativeEvent.target.value;
                break;
            case 85:
                newOrderModel.userFields.userFields86 = event.nativeEvent.target.value;
                break;
            case 86:
                newOrderModel.userFields.userFields87 = event.nativeEvent.target.value;
                break;
            case 87:
                newOrderModel.userFields.userFields88 = event.nativeEvent.target.value;
                break;
            case 88:
                newOrderModel.userFields.userFields89 = event.nativeEvent.target.value;
                break;
            case 89:
                newOrderModel.userFields.userFields90 = event.nativeEvent.target.value;
                break;
            case 90:
                newOrderModel.userFields.userFields91 = event.nativeEvent.target.value;
                break;
            case 91:
                newOrderModel.userFields.userFields92 = event.nativeEvent.target.value;
                break;
            case 92:
                newOrderModel.userFields.userFields93 = event.nativeEvent.target.value;
                break;
            case 93:
                newOrderModel.userFields.userFields94 = event.nativeEvent.target.value;
                break;
            case 94:
                newOrderModel.userFields.userFields95 = event.nativeEvent.target.value;
                break;
            case 95:
                newOrderModel.userFields.userFields96 = event.nativeEvent.target.value;
                break;
            case 96:
                newOrderModel.userFields.userFields97 = event.nativeEvent.target.value;
                break;
            case 97:
                newOrderModel.userFields.userFields98 = event.nativeEvent.target.value;
                break;
            case 98:
                newOrderModel.userFields.userFields99 = event.nativeEvent.target.value;
                break;
            case 99:
                newOrderModel.userFields.userFields100 = event.nativeEvent.target.value;
                break;
            case 100:
                newOrderModel.userFields.userFields101 = event.nativeEvent.target.value;
                break;
            case 101:
                newOrderModel.userFields.userFields102 = event.nativeEvent.target.value;
                break;
            case 102:
                newOrderModel.userFields.userFields103 = event.nativeEvent.target.value;
                break;
            case 103:
                newOrderModel.userFields.userFields104 = event.nativeEvent.target.value;
                break;
            case 104:
                newOrderModel.userFields.userFields105 = event.nativeEvent.target.value;
                break;
            case 105:
                newOrderModel.userFields.userFields106 = event.nativeEvent.target.value;
                break;
            case 106:
                newOrderModel.userFields.userFields107 = event.nativeEvent.target.value;
                break;
            case 107:
                newOrderModel.userFields.userFields108 = event.nativeEvent.target.value;
                break;
            case 108:
                newOrderModel.userFields.userFields109 = event.nativeEvent.target.value;
                break;
            case 109:
                newOrderModel.userFields.userFields110 = event.nativeEvent.target.value;
                break;
            case 110:
                newOrderModel.userFields.userFields111 = event.nativeEvent.target.value;
                break;
            case 111:
                newOrderModel.userFields.userFields112 = event.nativeEvent.target.value;
                break;
            case 112:
                newOrderModel.userFields.userFields113 = event.nativeEvent.target.value;
                break;
            case 113:
                newOrderModel.userFields.userFields114 = event.nativeEvent.target.value;
                break;
            case 114:
                newOrderModel.userFields.userFields115 = event.nativeEvent.target.value;
                break;
            case 115:
                newOrderModel.userFields.userFields116 = event.nativeEvent.target.value;
                break;
            case 116:
                newOrderModel.userFields.userFields117 = event.nativeEvent.target.value;
                break;
            case 117:
                newOrderModel.userFields.userFields118 = event.nativeEvent.target.value;
                break;
            case 118:
                newOrderModel.userFields.userFields119 = event.nativeEvent.target.value;
                break;
            case 119:
                newOrderModel.userFields.userFields120 = event.nativeEvent.target.value;
                break;
            case 120:
                newOrderModel.userFields.userFields121 = event.nativeEvent.target.value;
                break;
            case 121:
                newOrderModel.userFields.userFields122 = event.nativeEvent.target.value;
                break;
            case 122:
                newOrderModel.userFields.userFields123 = event.nativeEvent.target.value;
                break;
            case 123:
                newOrderModel.userFields.userFields124 = event.nativeEvent.target.value;
                break;
            case 124:
                newOrderModel.userFields.userFields125 = event.nativeEvent.target.value;
                break;
            case 125:
                newOrderModel.userFields.userFields126 = event.nativeEvent.target.value;
                break;
            case 126:
                newOrderModel.userFields.userFields127 = event.nativeEvent.target.value;
                break;
            case 127:
                newOrderModel.userFields.userFields128 = event.nativeEvent.target.value;
                break;
            case 128:
                newOrderModel.userFields.userFields129 = event.nativeEvent.target.value;
                break;
            case 129:
                newOrderModel.userFields.userFields130 = event.nativeEvent.target.value;
                break;
            case 130:
                newOrderModel.userFields.userFields131 = event.nativeEvent.target.value;
                break;

            default:
                break
        }

        refreshModel(newOrderModel);

    };

    changeStaticUserFields = async (field, value) => {
        const { newOrderModel, refreshModel } = this.props;
        newOrderModel[field] = value;
        refreshModel(newOrderModel);
    }

    returnValue = index => {
        const { newOrderModel } = this.props;

        let value = "";
        switch (index) {
            case 0:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields1 : "";
                break;
            case 1:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields2 : "";
                break;
            case 2:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields3 : "";
                break;
            case 3:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields4 : "";
                break;
            case 4:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields5 : "";
                break;
            case 5:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields6 : "";
                break;
            case 6:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields7 : "";
                break;
            case 7:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields8 : "";
                break;
            case 8:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields9 : "";
                break;
            case 9:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields10 : "";
                break;
            case 10:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields11 : "";
                break;
            case 11:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields12 : "";
                break;
            case 12:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields13 : "";
                break;
            case 13:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields14 : "";
                break;
            case 14:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields15 : "";
                break;
            case 15:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields16 : "";
                break;
            case 16:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields17 : "";
                break;
            case 17:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields18 : "";
                break;
            case 18:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields19 : "";
                break;
            case 19:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields20 : "";
                break;
            case 20:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields21 : "";
                break;
            case 21:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields22 : "";
                break;
            case 22:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields23 : "";
                break;
            case 23:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields24 : "";
                break;
            case 24:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields25 : "";
                break;
            case 25:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields26 : "";
                break;
            case 26:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields27 : "";
                break;
            case 27:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields28 : "";
                break;
            case 28:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields29 : "";
                break;
            case 29:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields30 : "";
                break;
            case 30:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields31 : "";
                break;
            case 31:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields32 : "";
                break;
            case 32:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields33 : "";
                break;
            case 33:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields34 : "";
                break;
            case 34:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields35 : "";
                break;
            case 35:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields36 : "";
                break;
            case 36:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields37 : "";
                break;
            case 37:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields38 : "";
                break;
            case 38:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields39 : "";
                break;
            case 39:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields40 : "";
                break;
            case 40:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields41 : "";
                break;
            case 41:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields42 : "";
                break;
            case 42:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields43 : "";
                break;
            case 43:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields44 : "";
                break;
            case 44:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields45 : "";
                break;
            case 45:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields46 : "";
                break;
            case 46:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields47 : "";
                break;
            case 47:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields48 : "";
                break;
            case 48:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields49 : "";
                break;
            case 49:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields50 : "";
                break;
            case 50:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields51 : "";
                break;
            case 51:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields52 : "";
                break;
            case 52:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields53 : "";
                break;
            case 53:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields54 : "";
                break;
            case 54:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields55 : "";
                break;
            case 55:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields56 : "";
                break;
            case 56:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields57 : "";
                break;
            case 57:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields58 : "";
                break;
            case 58:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields59 : "";
                break;
            case 59:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields60 : "";
                break;
            case 60:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields61 : "";
                break;
            case 61:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields62 : "";
                break;
            case 62:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields63 : "";
                break;
            case 63:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields64 : "";
                break;
            case 64:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields65 : "";
                break;
            case 65:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields66 : "";
                break;
            case 66:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields67 : "";
                break;
            case 67:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields68 : "";
                break;
            case 68:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields69 : "";
                break;
            case 69:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields70 : "";
                break;
            case 70:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields71 : "";
                break;
            case 71:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields72 : "";
                break;
            case 72:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields73 : "";
                break;
            case 73:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields74 : "";
                break;
            case 74:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields75 : "";
                break;
            case 75:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields76 : "";
                break;
            case 76:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields77 : "";
                break;
            case 77:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields78 : "";
                break;
            case 78:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields79 : "";
                break;
            case 79:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields80 : "";
                break;
            case 80:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields81 : "";
                break;
            case 81:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields82 : "";
                break;
            case 82:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields83 : "";
                break;
            case 83:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields84 : "";
                break;
            case 84:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields85 : "";
                break;
            case 85:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields86 : "";
                break;
            case 86:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields87 : "";
                break;
            case 87:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields88 : "";
                break;
            case 88:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields89 : "";
                break;
            case 89:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields90 : "";
                break;
            case 90:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields91 : "";
                break;
            case 91:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields92 : "";
                break;
            case 92:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields93 : "";
                break;
            case 93:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields94 : "";
                break;
            case 94:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields95 : "";
                break;
            case 95:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields96 : "";
                break;
            case 96:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields97 : "";
                break;
            case 97:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields98 : "";
                break;
            case 98:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields99 : "";
                break;
            case 99:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields100 : "";
                break;
            case 100:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields101 : "";
                break;
            case 101:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields102 : "";
                break;
            case 102:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields103 : "";
                break;
            case 103:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields104 : "";
                break;
            case 104:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields105 : "";
                break;
            case 105:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields106 : "";
                break;
            case 106:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields107 : "";
                break;
            case 107:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields108 : "";
                break;
            case 108:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields109 : "";
                break;
            case 109:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields110 : "";
                break;
            case 110:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields111 : "";
                break;
            case 111:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields112 : "";
                break;
            case 112:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields113 : "";
                break;
            case 113:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields114 : "";
                break;
            case 114:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields115 : "";
                break;
            case 115:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields116 : "";
                break;
            case 116:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields117 : "";
                break;
            case 117:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields118 : "";
                break;
            case 118:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields119 : "";
                break;
            case 119:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields120 : "";
                break;
            case 120:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields121 : "";
                break;
            case 121:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields122 : "";
                break;
            case 122:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields123 : "";
                break;
            case 123:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields124 : "";
                break;
            case 124:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields125 : "";
                break;
            case 125:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields126 : "";
                break;
            case 126:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields127 : "";
                break;
            case 127:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields128 : "";
                break;
            case 128:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields129 : "";
                break;
            case 129:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields130 : "";
                break;
            case 130:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields131 : "";
                break;
            default:
                break
        }

        return value;
    }

    getCorrelativo = async (tipoDocumento, serieDocumento) => {
        const { action, view, enableSpinner, showAlert, newOrderModel, refreshModel, editMode } = this.props;
        const { isDraftOWTQ = false } = this.props;
        const isTransferView = view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ;

        const automaticCorrelative = (action === 1 || (action === 2 && editMode && isDraftOWTQ)) && isTransferView;

        if (!automaticCorrelative) {
            return;
        }

        if (!tipoDocumento || !serieDocumento) {
            newOrderModel.userFields.userFields5 = '';
            refreshModel(newOrderModel);
            return;
        }

        try {
            if (typeof enableSpinner === 'function') {
                enableSpinner(true);
            }

            const response = await apiClient.getCorrelativo({ tipoDocumento, serieDocumento });

            if (!response?.status) {
                newOrderModel.userFields.userFields5 = '';
                refreshModel(newOrderModel);

                if (typeof showAlert === 'function') {
                    showAlert({ type: 'warning', message: response?.message || 'No se encontró un correlativo para el tipo y la serie seleccionados' });
                }

                return;
            }

            const correlativo = response?.data?.DocNum ?? '';
            newOrderModel.userFields.userFields5 = String(correlativo);

            refreshModel(newOrderModel);
        } catch (error) {
            // console.error('Error al consultar el correlativo:',
            //     error
            // );

            newOrderModel.userFields.userFields5 = '';
            refreshModel(newOrderModel);

            if (typeof showAlert === 'function') {
                showAlert({ type: 'error', message: 'Ocurrió un error al consultar el correlativo' });
            }
        } finally {
            if (typeof enableSpinner === 'function') {
                enableSpinner(false);
            }
        }
    };

    ChangeValue = async (event, index) => {
        const { action, view, editMode } = this.props;
        const { isDraftOWTQ = false } = this.props;
        const isTransferView = view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ;
        const automaticCorrelative = (action === 1 || (action === 2 && editMode && isDraftOWTQ)) && isTransferView;
        let value = null;
        if (event && event.value !== undefined) {
            value = event.value;
        } else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        if (index === 7) {
            const tipoDocumento = this.returnValue(0);

            value = value?.startsWith(`${tipoDocumento}-`)
                ? value.slice(tipoDocumento.length + 1)
                : value ?? null;
        }
        const fieldEvent = { nativeEvent: { target: { value } } };

        await this.changeUserFieldsDocument(fieldEvent, index);

        if (index === 0) {
            await this.changeUserFieldsDocument(
                { nativeEvent: { target: { value: null } } }, 7);

            if (automaticCorrelative) {
                await this.changeUserFieldsDocument(
                    { nativeEvent: { target: { value: '' } } }, 4);
            }
            return;
        }

        if (automaticCorrelative && index === 7) {
            const tipoDocumento = this.returnValue(0);
            const serieDocumento = value;

            if (!tipoDocumento || !serieDocumento) {
                await this.changeUserFieldsDocument(
                    { nativeEvent: { target: { value: '' } } }, 4);
                return;
            }

            await this.getCorrelativo(tipoDocumento, serieDocumento);
        }
    };
    renderFieldTypeSelect = (json) => {
        const { action, editMode, view } = this.props;
        const tipoDoc = this.returnValue(0);
        const { isDraftOWTQ = false } = this.props;
        const isTransferView = view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ;
        const isCorrelativo = Number(json.fieldId) === 22 || Number(json.IdValue) === 4;
        const disableCorrelative = isTransferView && isCorrelativo;
        const filteredOptions =
            Number(json.fieldId) === 36 && tipoDoc
                ? (json.options ?? []).filter(
                    option => option.value?.startsWith(`${tipoDoc}-`)
                )
                : (json.options ?? []);
        const isDisabledByTipoDoc = Number(json.fieldId) === 36 && !tipoDoc;
        const currValue = Number(json.fieldId) === 36 ? `${tipoDoc}-${this.returnValue(json.IdValue)}` : this.returnValue(json.IdValue);
        const isDisabled = disableCorrelative || isDisabledByTipoDoc || (action === 2 && !editMode);

        return (
            <tr>
                <td>
                    <label className="font-weight-bold" id={`userField-${json.IdValue}`}>{json.name}</label>
                </td>
                <td>
                    {(filteredOptions?.length ?? 0) > 0 ? (
                        <Select
                            menuPlacement="auto"
                            options={isDisabledByTipoDoc ? [] : filteredOptions}
                            value={isDisabledByTipoDoc ? null : filteredOptions.find(option => option.value === currValue) || null}
                            onChange={async (event) => await this.ChangeValue(event, json.IdValue)}
                            placeholder="Buscar..."
                            isDisabled={isDisabled}
                            isSearchable
                            isClearable={!disableCorrelative}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: 'transparent', borderColor: '#ced4da', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: '#000' }),
                                singleValue: (base) => ({ ...base, color: '#000' })
                            }}
                        />
                    ) : (
                        <input className="form-control" type="text"
                            value={this.returnValue(json.IdValue) ?? ''}
                            onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                            disabled={isDisabled} />
                    )}
                </td>
            </tr>
        );
    };

    renderFieldType1 = (json) => {
        const { action, editMode, view } = this.props;
        const { isDraftOWTQ = false } = this.props;
        const isTransferView = view === 'transfersRequest' || view === 'transfers' || isDraftOWTQ;
        const isCorrelativo = Number(json.fieldId) === 22 || Number(json.IdValue) === 4;
        const disableCorrelative = isTransferView && isCorrelativo;
        const isDisabled = disableCorrelative || (action === 2 && !editMode);

        return (
            <tr>
                <td>
                    <label className="font-weight-bold" id={`userField-${json.IdValue}`}>{json.name}</label>
                </td>
                <td>
                    <input className="form-control" type="text"
                        value={this.returnValue(json.IdValue) ?? ''}
                        onChange={(event) =>this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={isDisabled} />
                </td>
            </tr>
        );
    };

    renderFieldType2 = (json) => {
        const { action, editMode } = this.props;

        const fieldId = json.IdValue;
        const fieldName = json.name;
        const isPlantaField = fieldName === 'PLANTA';

        const currentValue = this.returnValue(fieldId);
        const selectComponent = isPlantaField ? (
            <>
                <input
                    list={`datalist-${fieldId}`}
                    className="form-control"
                    disabled={(action === 2 && !editMode) ? true : false}
                    value={currentValue || ''}
                    onChange={(event) => {
                        this.changeUserFieldsDocument(event, fieldId);
                    }}
                    placeholder="Escriba o seleccione planta..."
                />

                <datalist id={`datalist-${fieldId}`}>
                    {json.options.map(option => (
                        <option key={option.FldValue} value={option.FldValue}>
                            {option.Descr}
                        </option>
                    ))}
                </datalist>
            </>
        ) : (
            <select className="form-control" disabled={(action == 2 && !editMode) ? true : false}
                value={currentValue}
                onChange={(event) => this.changeUserFieldsDocument(event, fieldId)}>

                {json.options.map(option => {

                    return (
                        <option key={option.FldValue} value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                    )
                })}
            </select>
        );

        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{fieldName}</label>
                </td>
                <td className="">
                    {selectComponent}
                </td>
            </tr>
        )
    }

    renderFieldType3 = (json) => {
        const { action, editMode } = this.props;
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="date" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={(action == 2 && !editMode) ? true : false}
                        max='9999-12-31'
                        value={this.returnValue(json.IdValue)} />
                </td>
            </tr>
        )
    }

    renderFieldType4 = (json) => {
        const { action, editMode } = this.props;
        let CreateTime = (this.returnValue(json.IdValue) || '').toString();

        if (CreateTime.length > 0) {
            let position = CreateTime.length - 2;
            CreateTime = CreateTime.slice(0, position) + ":" + CreateTime.slice(position, CreateTime.length)
        }
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="time" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={(action == 2 && !editMode) ? true : false}
                        value={CreateTime || ''} />
                </td>
            </tr>
        )
    }


    renderUserFieldsInvoice = () => {
        const { newOrderModel, action, editMode } = this.props;

        return (
            <Fragment>

                {json.allUserFields.map((field) => {
                    if (field.fieldType == 1 && field.enabled) {
                        return this.renderFieldType1(field);
                    } else if (field.fieldType == 2 && field.enabled) {
                        return this.renderFieldType2(field);
                    }
                })}
            </Fragment>
        )
    };

    renderStaticUserFields = () => {
        const { view, newView, newOrderModel, action, editMode } = this.props;
        let vista = newView || view;
        return (
            <>
                {((vista === 'quotations' || vista === 'orderSales' || vista === 'deliveries' || vista === 'invoice' || vista === 'invoiceAdvance' || vista === 'return' || vista === 'creditNote' || vista === 'debitNote') ||
                    (vista === 'transfersRequest' || vista === 'transfers' || vista === 'invoiceAuthorization' || vista === 'invoiceBorrador' || vista === 'draft')) &&
                    // Documento relacionado para documentos de ventas
                    <tr>
                        <td className="">
                            <label className="font-weight-bold" id='userField1'>Documento relacionado</label>
                        </td>
                        <td className="">
                            <input className="form-control" type="text"
                                onChange={(event) => this.changeStaticUserFields('U_FMB_RelatedFolio', event.target.value)}
                                disabled={(action === 2 && !editMode) ? true : false}
                                value={newOrderModel.U_FMB_RelatedFolio ?? ''} />
                        </td>
                    </tr>
                }
            </>
        );
    }

    renderallUserFields = () => {
        const { configHeaderUserFields } = this.props;
        return (
            <Fragment>
                {json.allUserFields.map((field, index) => {

                    if (configHeaderUserFields.length && configHeaderUserFields[index].enabled) {
                        if (field.fieldType == 1 && field.enabled) {
                            return this.renderFieldType1(field);
                        } else if (field.fieldType == 2 && field.enabled) {
                            return this.renderFieldType2(field);
                        } else if (field.fieldType == 3 && field.enabled) {
                            return this.renderFieldTypeSelect(field);
                        }
                    }
                })}
                {this.renderStaticUserFields()}
            </Fragment>
        )
    };
    renderWareHouseFields = () => {
        const { configHeaderUserFields } = this.props;
        return (
            <Fragment>
                {json.userFieldsWareHouse.map((field, index) => {

                    if (configHeaderUserFields.length && configHeaderUserFields[index].enabled) {
                        if (field.fieldType == 1 && field.enabled) {
                            return this.renderFieldType1(field);
                        } else if (field.fieldType == 2 && field.enabled) {
                            return this.renderFieldType2(field);
                        }
                    }
                })}
            </Fragment>
        )
    };

    renderUserFieldsPayment = () => {
        const { newOrderModel, action, editMode, configHeaderUserFields } = this.props;
        return (
            <Fragment>
                {json.userFieldsPayment.map((field, index) => {
                    if (configHeaderUserFields.length && configHeaderUserFields[index].enabled) {
                        if (field.fieldType == 1 && field.enabled) {
                            return this.renderFieldType1(field);
                        } else if (field.fieldType == 2 && field.enabled) {
                            return this.renderFieldType2(field);
                        }
                    }
                })}
            </Fragment>
        )
    };

    renderUserFields = () => {
        const { view, newView } = this.props;
        let vista = newView || view;
        let body = <tbody></tbody>;
        switch (vista) {
            case 'quotations':
                body = this.renderallUserFields(); // this.renderUserFieldsInvoice();
                break;
            case 'orderSales':
                body = this.renderallUserFields(); // this.renderUserFieldsInvoice();
                break;
            case 'deliveries':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'invoice':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'invoiceAdvance':
                body = this.renderallUserFields();
                break;
            case 'return':
                body = this.renderallUserFields();
                break;
            case 'creditNote':
                body = this.renderallUserFields();
                break;
            case 'debitNote':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'transfers':
                body = this.renderallUserFields();
                break;
            case 'transfersRequest':
                body = this.renderallUserFields();
                break;
            case 'payment':
                body = this.renderUserFieldsPayment(); //  this.renderUserFieldsPayment();
                break;
            case 'invoiceBorrador':
                body = this.renderallUserFields();
                break;
            case 'invoiceAuthorization':
                body = this.renderallUserFields();
                break;
            case 'PurchaseOrder':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'purchaseReturn':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'GoodsReceipt':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'PurchaseRequest':
                body = this.renderallUserFields();
                break;
            case 'SalesHelmets':
                body = this.renderallUserFields();
                break;
            case 'ExitHelmets':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'purchaseInvoice':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'purchaseCreditNotes':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'invoiceReserve':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'transfersEntry':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'transfersOutput':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'wareHouseAdmin':
                body = this.renderWareHouseFields();
                break;
            case 'PurchaseQuotation':
                body = this.renderallUserFields(); //  this.renderUserFieldsInvoice();
                break;
            case 'draft':
                body = this.renderallUserFields();
                break;
            default:
                break;
        }
        return body;
    };

    render() {
        const { openConfigUserFieldsHeaders } = this.props;


        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="userFieldsModal" style={{ zIndex: 91 }} role="dialog" aria-labelledby="userFieldsModal" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Campos de Usuario</h4>

                            <button className="btnUserFields" onClick={openConfigUserFieldsHeaders}
                                style={{ fontWeight: '500' }}><i className="fas fa-cog"> <i style={{ fontSize: '12px' }}> Configurar</i></i>
                            </button>
                            &nbsp;
                            <button type="button" className="close" onClick={this.closeUserFields} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 450, maxHeight: 570 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tbody>
                                                    <tr>
                                                        <td className="sticky-header table-header-yellow ">Nombre</td>
                                                        <td className="sticky-header table-header-yellow "
                                                            style={{ width: 250, textAlign: "center" }}> Valor
                                                        </td>
                                                    </tr>
                                                    {this.renderUserFields()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={this.closeUserFields}>Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        );
    }
}

export default UserFieldsModal;